import { Component, OnInit } from '@angular/core';
import { SIBSCRIPTION_FEATURES_SLIDER } from '@app/core';
import { CommonService } from '@app/core/services/common.service';

@Component({
  selector: 'app-subscription-features-slider',
  templateUrl: './subscription-features-slider.component.html',
  styleUrls: ['./subscription-features-slider.component.scss'],
})
export class SubscriptionFeaturesSliderComponent implements OnInit {
  constructor(public _common:CommonService) {}
  customOptions = SIBSCRIPTION_FEATURES_SLIDER;
  ngOnInit(): void {}
}
